import {ReactNode} from "react";
import type {GroupBase, Props as ReactSelectProps, Theme} from "react-select";
import {components} from "react-select";

import {ChevronDownIcon} from "@pg-design/icons";
import {Radio} from "@pg-design/radio";
import type {DropdownIndicatorProps, OptionProps, StylesConfig} from "@pg-design/select-module";

import * as styles from "./LangSelect.module.css";

export interface ILangSelectOption {
    value: string;
    label: ReactNode;
}

export type ILangSelectStyles = StylesConfig<ILangSelectOption, false>;

/** Matches design_system Select theme – select-module omits controlHeight: 48 */
export const getLangSelectTheme = (theme: Theme): Theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        neutral20: "var(--colors-gray-600)",
        neutral30: "var(--colors-gray-600)",
        primary: "var(--colors-info)",
        primary25: "var(--colors-gray-200)"
    },
    spacing: {...theme.spacing, controlHeight: 48},
    borderRadius: 8
});

export const getLangSelectStyles = (userStyles: ILangSelectStyles | undefined, isMobile: boolean): ILangSelectStyles => ({
    ...userStyles,
    control: (provided, state) => {
        const base = userStyles?.control?.(provided, state) ?? provided;

        return {
            ...base,
            backgroundColor: state.isDisabled ? "var(--colors-gray-100)" : "var(--colors-secondary)",
            borderColor: "var(--colors-gray-600)",
            boxShadow: "none",
            cursor: "pointer",
            minHeight: 48,
            height: "auto",
            padding: 0,
            "&:hover": {
                borderColor: "var(--colors-gray-600)",
                boxShadow: "none"
            },
            ...(state.isFocused && {
                borderColor: "var(--colors-gray-600)",
                boxShadow: "none"
            })
        };
    },
    valueContainer: (provided, state) => {
        const base = userStyles?.valueContainer?.(provided, state) ?? provided;

        return {
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "0.8rem",
            paddingRight: 0,
            height: "auto"
        };
    },
    indicatorsContainer: (provided, state) => {
        const base = userStyles?.indicatorsContainer?.(provided, state) ?? provided;

        return {
            ...base,
            cursor: "pointer"
        };
    },
    singleValue: (provided, state) => {
        const base = userStyles?.singleValue?.(provided, state) ?? provided;

        return {
            ...base,
            color: "var(--colors-white)",
            cursor: "pointer"
        };
    },
    dropdownIndicator: (provided, state) => {
        const base = userStyles?.dropdownIndicator?.(provided, state) ?? provided;

        return {
            ...base,
            color: "var(--colors-white)",
            padding: 0,
            paddingRight: "1.6rem"
        };
    },
    indicatorSeparator: () => ({
        display: "none"
    }),
    input: (provided, state) => {
        const base = userStyles?.input?.(provided, state) ?? provided;

        return {
            ...base,
            margin: 0,
            padding: 0
        };
    },
    ...(isMobile
        ? {}
        : {
              menu: (provided) => {
                  const base = userStyles?.menu?.(provided, {} as never) ?? provided;

                  return {
                      ...base,
                      backgroundColor: "var(--colors-secondary)",
                      border: "1px solid var(--colors-gray-600)",
                      borderRadius: "0.8rem",
                      overflow: "hidden",
                      padding: "0.8rem",
                      zIndex: 1000
                  };
              },
              menuList: (provided) => {
                  const base = userStyles?.menuList?.(provided, {} as never) ?? provided;

                  return {
                      ...base,
                      padding: 0
                  };
              },
              option: (provided, state) => {
                  const base = userStyles?.option?.(provided, state) ?? provided;

                  return {
                      ...base,
                      backgroundColor: "var(--colors-secondary)",
                      color: "var(--colors-white)",
                      cursor: "pointer",
                      padding: "0.8rem 0",
                      "&:active": {
                          backgroundColor: "var(--colors-secondary)"
                      }
                  };
              }
          })
});

const DarkDropdownIndicator = (indicatorProps: DropdownIndicatorProps<ILangSelectOption, false>) => (
    <components.DropdownIndicator {...indicatorProps}>
        <ChevronDownIcon size="2" fill="var(--colors-white)" />
    </components.DropdownIndicator>
);

const DarkDesktopOption = (radioName: string) => (optionProps: OptionProps<ILangSelectOption, false>) => {
    const {data, isSelected} = optionProps;
    const labelId = `lang-select-label-${data.value}`;

    return (
        <components.Option {...optionProps}>
            <div className={styles.darkOptionRow}>
                <Radio readOnly aria-labelledby={labelId} id={`lang-select-radio-${data.value}`} isActive={isSelected} name={radioName} value={data.value} />

                <div className={styles.darkOptionLabel} id={labelId}>
                    {data.label}
                </div>
            </div>
        </components.Option>
    );
};

export type ILangSelectComponents = NonNullable<ReactSelectProps<ILangSelectOption, false, GroupBase<ILangSelectOption>>["components"]>;

export const getLangSelectComponents = ({
    isMobile,
    radioName,
    userComponents
}: {
    isMobile: boolean;
    radioName: string;
    userComponents?: ILangSelectComponents;
}): ILangSelectComponents => {
    if (isMobile) {
        return {
            ...userComponents,
            DropdownIndicator: DarkDropdownIndicator
        };
    }

    return {
        ...userComponents,
        Option: DarkDesktopOption(radioName),
        DropdownIndicator: DarkDropdownIndicator
    };
};
import {ReactNode} from "react";
import type {GroupBase, Props as ReactSelectProps, Theme} from "react-select";
import {components} from "react-select";

import {ChevronDownIcon} from "@pg-design/icons";
import {Radio} from "@pg-design/radio";
import type {DropdownIndicatorProps, OptionProps, StylesConfig} from "@pg-design/select-module";

import * as styles from "./LangSelect.module.css";

export interface ILangSelectOption {
    value: string;
    label: ReactNode;
}

export type ILangSelectStyles = StylesConfig<ILangSelectOption, false>;

/** Matches design_system Select theme – select-module omits controlHeight: 48 */
export const getLangSelectTheme = (theme: Theme): Theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        neutral20: "var(--colors-gray-600)",
        neutral30: "var(--colors-gray-600)",
        primary: "var(--colors-info)",
        primary25: "var(--colors-gray-200)"
    },
    spacing: {...theme.spacing, controlHeight: 48},
    borderRadius: 8
});

export const getLangSelectStyles = (userStyles: ILangSelectStyles | undefined, isMobile: boolean): ILangSelectStyles => ({
    ...userStyles,
    control: (provided, state) => {
        const base = userStyles?.control?.(provided, state) ?? provided;

        return {
            ...base,
            backgroundColor: state.isDisabled ? "var(--colors-gray-100)" : "var(--colors-secondary)",
            borderColor: "var(--colors-gray-600)",
            boxShadow: "none",
            cursor: "pointer",
            minHeight: 48,
            height: "auto",
            padding: 0,
            "&:hover": {
                borderColor: "var(--colors-gray-600)",
                boxShadow: "none"
            },
            ...(state.isFocused && {
                borderColor: "var(--colors-gray-600)",
                boxShadow: "none"
            })
        };
    },
    valueContainer: (provided, state) => {
        const base = userStyles?.valueContainer?.(provided, state) ?? provided;

        return {
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "0.8rem",
            paddingRight: 0,
            height: "auto"
        };
    },
    indicatorsContainer: (provided, state) => {
        const base = userStyles?.indicatorsContainer?.(provided, state) ?? provided;

        return {
            ...base,
            cursor: "pointer"
        };
    },
    singleValue: (provided, state) => {
        const base = userStyles?.singleValue?.(provided, state) ?? provided;

        return {
            ...base,
            color: "var(--colors-white)",
            cursor: "pointer"
        };
    },
    dropdownIndicator: (provided, state) => {
        const base = userStyles?.dropdownIndicator?.(provided, state) ?? provided;

        return {
            ...base,
            color: "var(--colors-white)",
            padding: 0,
            paddingRight: "1.6rem"
        };
    },
    indicatorSeparator: () => ({
        display: "none"
    }),
    input: (provided, state) => {
        const base = userStyles?.input?.(provided, state) ?? provided;

        return {
            ...base,
            margin: 0,
            padding: 0
        };
    },
    ...(isMobile
        ? {}
        : {
              menu: (provided) => {
                  const base = userStyles?.menu?.(provided, {} as never) ?? provided;

                  return {
                      ...base,
                      backgroundColor: "var(--colors-secondary)",
                      border: "1px solid var(--colors-gray-600)",
                      borderRadius: "0.8rem",
                      overflow: "hidden",
                      padding: "0.8rem",
                      zIndex: 1000
                  };
              },
              menuList: (provided) => {
                  const base = userStyles?.menuList?.(provided, {} as never) ?? provided;

                  return {
                      ...base,
                      padding: 0
                  };
              },
              option: (provided, state) => {
                  const base = userStyles?.option?.(provided, state) ?? provided;

                  return {
                      ...base,
                      backgroundColor: "var(--colors-secondary)",
                      color: "var(--colors-white)",
                      cursor: "pointer",
                      padding: "0.8rem 0",
                      "&:active": {
                          backgroundColor: "var(--colors-secondary)"
                      }
                  };
              }
          })
});

const DarkDropdownIndicator = (indicatorProps: DropdownIndicatorProps<ILangSelectOption, false>) => (
    <components.DropdownIndicator {...indicatorProps}>
        <ChevronDownIcon size="2" fill="var(--colors-white)" />
    </components.DropdownIndicator>
);

const DarkDesktopOption = (radioName: string) => (optionProps: OptionProps<ILangSelectOption, false>) => {
    const {data, isSelected} = optionProps;
    const labelId = `lang-select-label-${data.value}`;

    return (
        <components.Option {...optionProps}>
            <div className={styles.darkOptionRow}>
                <Radio readOnly aria-labelledby={labelId} id={`lang-select-radio-${data.value}`} isActive={isSelected} name={radioName} value={data.value} />

                <div className={styles.darkOptionLabel} id={labelId}>
                    {data.label}
                </div>
            </div>
        </components.Option>
    );
};

export type ILangSelectComponents = NonNullable<ReactSelectProps<ILangSelectOption, false, GroupBase<ILangSelectOption>>["components"]>;

export const getLangSelectComponents = ({
    isMobile,
    radioName,
    userComponents
}: {
    isMobile: boolean;
    radioName: string;
    userComponents?: ILangSelectComponents;
}): ILangSelectComponents => {
    if (isMobile) {
        return {
            ...userComponents,
            DropdownIndicator: DarkDropdownIndicator
        };
    }

    return {
        ...userComponents,
        Option: DarkDesktopOption(radioName),
        DropdownIndicator: DarkDropdownIndicator
    };
};
